/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ../locale-data/index.js (ignored)
// module id = 1749
// module chunks = 0